module.exports = __webpack_public_path__ + "img/changeFinish-1.73a9cf7.webp";